import React from 'react';
type SlideHeaderProps = {
  eyebrow: string;
  title: string;
  subtitle?: string;
};
export function SlideHeader({
  eyebrow,
  title,
  subtitle
}: SlideHeaderProps) {
  return <header className="shrink-0" data-id="element-20" data-mp="1clqsqygsqk0k">
      <p className="flex items-center gap-[0.8cqw] font-heading text-[1.15cqw] font-semibold uppercase tracking-[0.16em] text-mm-mid-gray" data-id="element-21" data-mp="1cm0ci4b8zuxt">
        <span className="h-[0.8cqw] w-[0.8cqw] bg-mm-orange" aria-hidden="true" data-id="element-22" data-mp="17oqnuqvonnb1" />
        {eyebrow}
      </p>
      <h2 className="mt-[0.6cqw] font-heading text-[3.4cqw] font-bold leading-[1.05] tracking-tight text-mm-black" data-id="element-23" data-mp="jywc6cn3o4sd">
        {title}
      </h2>
      {subtitle ? <p className="mt-[0.6cqw] font-body text-[1.5cqw] text-mm-muted-charcoal" data-id="element-24" data-mp="tw21pgg2fnqh">
          {subtitle}
        </p> : null}
      <div className="mt-[1.2cqw] h-[0.2cqw] w-[6cqw] bg-mm-orange" aria-hidden="true" data-id="element-25" data-mp="oy8uck310nom" />
    </header>;
}